import { Injectable } from '@angular/core';
import { VantageShellService } from '../../vantage-shell/vantage-shell.service';
import { LoggerService } from '../../logger/logger.service';
import { DeviceService } from '../../device/device.service';
@Injectable()
export class CameraSectionService {
	private Windows: any;
	private DeviceInformation: any;
	private DeviceClass: any;

	private N2PBIOS = 'N2P';

	constructor(
		private logger: LoggerService,
		private deviceService: DeviceService,
		shellService: VantageShellService
	) {
		this.Windows = shellService.getWindows();
		if (this.Windows) {
			this.DeviceInformation = this.Windows.Devices.Enumeration.DeviceInformation;
			this.DeviceClass = this.Windows.Devices.Enumeration.DeviceClass;
		}
	}

	public async isAllInOneMachine() {
		let frontCameraCount = 0;
		try {
			const panel = this.Windows.Devices.Enumeration.Panel.front;
			const devices = await this.DeviceInformation.findAllAsync(this.DeviceClass.videoCapture);
			devices.forEach((cameraDeviceInfo) => {
				if (cameraDeviceInfo.enclosureLocation !== null && cameraDeviceInfo.enclosureLocation.panel === panel) {
					frontCameraCount = frontCameraCount + 1;
				}
			});
			this.logger.debug('frontCameraCount: ', frontCameraCount);
			return frontCameraCount > 0 ? true : false;
		} catch (error) {
			this.logger.debug('isAllInOneMachine:', error.message);
			return frontCameraCount > 0 ? true : false;
		}
	}

	public async isN2PBios() {
		const machineInfo = await this.deviceService.getMachineInfo();
		// for yoga book need to check first 4 character
		const biosVersion = machineInfo.biosVersion.substr(0, 3);
		return biosVersion === this.N2PBIOS;
	}
}
